import { FastingDietTypes } from './../../../core/model/diet-type-model';
import { Component, Input, OnInit } from '@angular/core';
import {
  ManDietTypes,
  WomanDietTypes,
} from 'src/app/core/model/diet-type-model';
import { DietTypeService } from 'src/app/data/repository/generate-repository/diet-type.service';
import { GenerateService } from 'src/app/data/repository/generate-repository/generate.service';
import { UserDataService } from 'src/app/data/repository/user-repository/user-data.service';
import { ButtonInputModel } from '../../general/button/button.component';
import { GenerateShared } from '../../general/shared/generate-shared';

@Component({
  selector: 'app-diet-personal-type',
  templateUrl: './diet-personal-type.component.html',
  styleUrls: ['./diet-personal-type.component.scss'],
})
export class DietPersonalTypeComponent implements OnInit {
  @Input() isDetail = false;
  configButtons: ButtonInputModel[] = new Array();
  type: string;

  constructor(
    private dietTypeService: DietTypeService,
    private generateShared: GenerateShared,
    private userDataService: UserDataService,
    private generateService: GenerateService
  ) {}

  ngOnInit() {
    if (!this.generateShared.selectedDietType) {
      this.back();
      return;
    }
    if (this.isDetail) {
      this.type = this.generateShared.goal;
    } else {
      if (this.generateShared.goal) {
        this.type = this.generateShared.goal;
      } else {
        this.type = '';
      }
    }
    if (this.generateShared.selectedDietType.fasting) {
      FastingDietTypes.forEach((type) => {
        // console.log(type)
        this.configButtons.push({
          isOneLine: true,
          title: type.getName(),
          imgUrl: type.getImg(),
          type: 'diet-type',
          id: type.getID(),
          isSelected:
            this.dietTypeService.getDietTypeIdByEngName(this.type) ===
            type.getID()
              ? true
              : false,
        });
      });
      return;
    }
    // console.log( this.dietTypeService.getDietTypeIdByEngName(this.type), this.type)
    this.userDataService.getUser().then((user) => {
      if (user) {
        if (user.sex === 'male') {
          ManDietTypes.forEach((type) => {
            // console.log(type)
            this.configButtons.push({
              isOneLine: true,
              title: type.getName(),
              imgUrl: type.getImg(),
              type: 'diet-type',
              id: type.getID(),
              isSelected:
                this.dietTypeService.getDietTypeIdByEngName(this.type) ===
                type.getID()
                  ? true
                  : false,
            });
          });
        } else if (user.sex === 'female') {
          WomanDietTypes.forEach((type) => {
            // console.log(type)
            this.configButtons.push({
              isOneLine: true,
              title: type.getName(),
              imgUrl: type.getImg(),
              type: 'diet-type',
              id: type.getID(),
              isSelected:
                this.dietTypeService.getDietTypeIdByEngName(this.type) ===
                type.getID()
                  ? true
                  : false,
            });
          });
        }
      }
    });
  }

  back() {
    this.generateService.back();
  }
}
